import React from 'react'
import { Box, Grid } from '@mui/material'
import { type FormikContextType, useFormikContext } from 'formik'
import FormikTextField from '../../../components/ui-widgets/FormikTextField'
import { type PortfolioSettlementDto } from '../../../../api-schema-types/asset-holdings/AdminPortfolioSettlementDomainDtos'
import { type EditSettlementFormProps } from './EditSettlementForm'

const ViewSettlementSummary: React.FC<EditSettlementFormProps> = ({ settlement }: EditSettlementFormProps) => {
  const formikProps: FormikContextType<PortfolioSettlementDto> = useFormikContext()

  return (
    <>
      <Box>
        <Grid container spacing={4} >

          {/* ==================================================================================================== */}

          <Grid item md={6}>
            <FormikTextField formikProps={formikProps} fieldName={'buyer'} label={'Buyer'} type={'text'} locked={true}/>
          </Grid>

          <Grid item md={2}>
            <FormikTextField formikProps={formikProps} fieldName={'transferDate'} label={'Tranfer Date'} type={'text'} locked={true}/>
          </Grid>

          <Grid item md={2}>
            <FormikTextField formikProps={formikProps} fieldName={'state'} label={'State'} type={'text'} locked={true}/>
          </Grid>

          <Grid item md={6}></Grid>

          {/* ==================================================================================================== */}

        </Grid>

      </Box>
    </>
  )
}

export default ViewSettlementSummary
